import * as React from 'react';
export const threedsecureSvg = React.forwardRef(function threedsecureSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#E3E8EE',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M9.875 13.75v-2.5a6.25 6.25 0 0 1 12.5 0v2.5H23c.69 0 1.25.56 1.25 1.25v7.5a2.5 2.5 0 0 1-2.5 2.5H10.5A2.5 2.5 0 0 1 8 22.5V15c0-.69.56-1.25 1.25-1.25h.625Zm9.708 2.543a1 1 0 0 1 1.414 1.414l-4.79 4.798a1 1 0 0 1-1.414 0l-2.5-2.5a1 1 0 1 1 1.414-1.414l1.793 1.792 4.083-4.09Zm.292-2.543v-2.5a3.75 3.75 0 0 0-7.5 0v2.5h7.5Z',
      fill: '#697386',
    }),
  );
});
threedsecureSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var threedsecure = {
  category: 'brand',
  colorable: false,
  name: 'threedsecure',
  svg: threedsecureSvg,
};
